import { render, staticRenderFns } from "./ExamPackagePracticeDes.vue?vue&type=template&id=d8af1020&scoped=true&"
import script from "./ExamPackagePracticeDes.vue?vue&type=script&lang=js&"
export * from "./ExamPackagePracticeDes.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackagePracticeDes.vue?vue&type=style&index=0&id=d8af1020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8af1020",
  null
  
)

export default component.exports